/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Quick_FactsInputs */

const en_directory_detail_quick_facts = /** @type {(inputs: Directory_Detail_Quick_FactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At a glance`)
};

const zh_directory_detail_quick_facts = /** @type {(inputs: Directory_Detail_Quick_FactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

/**
* | output |
* | --- |
* | "At a glance" |
*
* @param {Directory_Detail_Quick_FactsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_quick_facts = /** @type {((inputs?: Directory_Detail_Quick_FactsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Quick_FactsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_quick_facts(inputs)
	return zh_directory_detail_quick_facts(inputs)
});
export { directory_detail_quick_facts as "directory.detail.quick_facts" }